import React from "react";

// Single crane in flight — minimalist line art (inspired by Japanese sumi-e)
export const CraneSilhouette = ({ className = "", color = "currentColor" }) => (
  <svg
    viewBox="0 0 200 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M6 70 C 30 60, 48 56, 70 58 C 78 46, 92 34, 110 34 C 116 28, 124 26, 132 30 C 136 24, 144 22, 150 26 L 148 34 C 156 34, 166 40, 170 50 C 186 52, 194 56, 198 66 C 178 68, 160 70, 148 70 C 140 82, 122 92, 102 92 C 86 94, 64 92, 46 84 C 34 82, 18 78, 6 70 Z"
      stroke={color}
      strokeWidth="1.25"
      strokeLinejoin="round"
      strokeLinecap="round"
      fill="none"
    />
    <circle cx="150" cy="28" r="1.6" fill={color} />
  </svg>
);

// Three cranes clustered — decorative header
export const CranesTrio = ({ className = "", color = "currentColor" }) => (
  <svg
    viewBox="0 0 300 160"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g fill="none" stroke={color} strokeWidth="1" strokeLinecap="round">
      <path d="M20 110 Q 60 80, 100 90 Q 120 70, 150 80 Q 160 60, 180 70" />
      <path d="M50 130 Q 90 110, 130 120 Q 160 100, 200 115" />
      <path d="M90 150 Q 140 130, 190 140 Q 230 125, 270 135" />
    </g>
  </svg>
);

// Simple origami crane silhouette
export const OrigamiCrane = ({ className = "", color = "currentColor" }) => (
  <svg
    viewBox="0 0 120 100"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M6 54 L 48 38 L 34 10 L 72 30 L 98 8 L 88 42 L 116 52 L 78 62 L 96 92 L 60 66 L 30 84 L 44 58 Z"
      fill={color}
      opacity="0.9"
    />
  </svg>
);

// Divider with a small crane centered on a thin line
export const CraneDivider = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-4 ${className}`}>
    <span className="h-px w-16 md:w-28 bg-ink/30" />
    <CraneSilhouette className="w-8 h-5 text-ink/60" />
    <span className="h-px w-16 md:w-28 bg-ink/30" />
  </div>
);

export default CraneSilhouette;
